import React, { ReactNode } from "react";
import Tooltip from "@charty/tooltip/histogram";
import { Range } from "@linkfluence/models/date";
import { Locale } from "@linkfluence/models/locale";
import { Metric } from "@linkfluence/models/metric";
import { getContent } from "./utils";

interface IProps {
  total?: number;
  range?: Range;
  metric: Metric;
  locale: Locale;
  count: number;
  label: string;
  color?: string;
  content?: ReactNode;
  isNormalized?: boolean;
  footer?: React.ReactNode;
}

const RadarlyWidgetsTooltipMetric = ({
  count,
  label,
  color,
  total,
  range,
  metric,
  locale,
  content,
  isNormalized,
  footer,
}: IProps) => {
  return (
    <Tooltip
      range={range}
      count={count}
      label={label}
      color={color}
      locale={locale}
      content={
        content
          ? content
          : getContent(locale, count, total, metric, isNormalized)
      }
      footer={footer}
    />
  );
};

export default RadarlyWidgetsTooltipMetric;
